import React, { useEffect, useState } from 'react';

const GTranslateDropdown = () => {
  const [selectedLang, setSelectedLang] = useState('en');

  const setLanguage = (lang) => {
    console.log('Selected language:', lang);
    setSelectedLang(lang);
    sessionStorage.setItem('secretbox_country_code', lang);

    const domain = window.location.hostname;

    if (lang === 'en') {
      console.log('Resetting to English...');
      deleteCookie('googtrans');
      deleteCookie('googtrans', '/', domain);
      window.location.reload();
      return;
    }

    const value = `/en/${lang}`;
    document.cookie = `googtrans=${value}; path=/`;
    document.cookie = `googtrans=${value}; domain=${domain}; path=/`;

    window.location.reload();
  };

  const deleteCookie = (name, path = '/', domain) => {
    document.cookie = `${name}=; path=${path}; ${
      domain ? `domain=${domain};` : ''
    } expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  };

  useEffect(() => {
    const countryCode = sessionStorage.getItem('secretbox_country_code');
    const defaultLangSet = sessionStorage.getItem('default_lang_set');

    if (countryCode && !defaultLangSet) {
      if (countryCode.toLowerCase() === 'pl') {
        setLanguage('pl');
        sessionStorage.setItem('default_lang_set', true);
      }
    } else if (!countryCode) {
      fetch('https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry')
        .then((response) => response.text())
        .then((country) => {
          const code = country.toLowerCase();
          sessionStorage.setItem('secretbox_country_code', code);
          if (code === 'pl') {
            setLanguage('pl');
          }
        })
        .catch((err) => {
          console.warn('Failed to get country:', err);
        });
    }
  }, []);



  return (
    <select
      className="custom_translate_dropdown gt_selector"
      value={selectedLang}
      
      onChange={(e) => setLanguage(e.target.value)}
    >
      <option value="en" style={{display:'none'}}>English</option>
      <option value="en">English</option>
      <option value="de">German</option>
      <option value="ar">Arabic</option>
      <option value="pl">Polish</option>
    </select>
  );
};

export default GTranslateDropdown;
